export function Room({
    uid,
    name,
    type,
    devicesAmount
} = {}) {
    return {
        uid,
        name,
        type,
        devicesAmount
    };
}